module.exports = __webpack_public_path__ + "img/gift.f3e6cb7f.png";